import { ConsentRequestPayload } from '@account/consents-shared-lib'

export const isMarketingConsentAccepted = (consents?: ConsentRequestPayload) => {
  const marketing_email = consents?.legalAcceptance.acceptances.some(
    acceptance => acceptance.documentName.includes('mrkt-email') && acceptance.accepted,
  )
  return marketing_email ?? false
}

export const isPaidMediaConsentAccepted = (consents?: ConsentRequestPayload) => {
  const paid_media = consents?.legalAcceptance.acceptances.some(
    acceptance => acceptance.documentName.includes('mrkt-paidmedia') && acceptance.accepted,
  )
  return paid_media ?? false
}
